/**
 * Subtle date break component for separating items by week
 */
function DateBreak({ label }) {
  return (
    <li className='date-break'>
      <span className='metadata-text secondary'>{label}</span>
    </li>
  )
}

export default DateBreak
